import type { AvatarType } from '@getgo/chameleon-core'
import type { IAvatarComponent } from '@getgo/chameleon-web'

export const GOTO_AVATAR = 'goto-avatar'

export interface AvatarProps extends Readonly<IAvatarComponent> {
  readonly showPresence?: boolean
  readonly usePresenceSnapshot?: boolean
  readonly givenName?: string
  readonly familyName?: string
  readonly profileImageUrl?: string
  readonly externalUserKey?: string
  readonly emailAddress?: string
  readonly icon?: string
  readonly iconBadge?: string
  readonly type?: AvatarType
}
